<div class="mt-4 flex flex-col justify-between sm:flex-row sm:items-center">
  <span class="text-muted-foreground text-sm">
    {{ getSelectedCount() }} of {{ getTotalRows() }} row(s) selected
  </span>
  <div class="mt-2 flex sm:mt-0">
    <!-- Page Size Selector -->
    <select
      [value]="getPageSize()"
      (change)="onPageSizeChange(+$any($event.target).value)"
      class="mr-1 inline-flex h-9 w-20 items-center justify-between rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
    >
      @for (size of pageSizeOptions(); track size) {
        <option [value]="size">{{ size }}</option>
      }
    </select>

    <!-- Pagination Buttons -->
    <div class="flex space-x-1">
      <button
        type="button"
        (click)="onPreviousPage()"
        [disabled]="!canPreviousPage()"
        class="bg-background border dark:bg-input/30 dark:border-input dark:hover:bg-input/50 disabled:opacity-50 disabled:pointer-events-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 font-medium gap-1.5 h-8 hover:bg-accent hover:text-accent-foreground inline-flex items-center justify-center outline-none px-3 rounded-md shadow-xs shrink-0 text-sm transition-all whitespace-nowrap"
      >
        Previous
      </button>
      <button
        type="button"
        (click)="onNextPage()"
        [disabled]="!canNextPage()"
        class="bg-background border dark:bg-input/30 dark:border-input dark:hover:bg-input/50 disabled:opacity-50 disabled:pointer-events-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 font-medium gap-1.5 h-8 hover:bg-accent hover:text-accent-foreground inline-flex items-center justify-center outline-none px-3 rounded-md shadow-xs shrink-0 text-sm transition-all whitespace-nowrap"
      >
        Next
      </button>
    </div>
  </div>
</div>
